import { Avatar, Group } from "@mantine/core";
import ChipText from "../chip-text/ChipText";

interface Props {
  avatar?: string;
  avatars?: string[];

  text: string | React.ReactNode;
  className?: string;
}

const AvatarWithText = ({ avatar, avatars, text, className }: Props) => {
  avatars ??= [avatar ?? ""];

  return (
    <Group className="mt-[44px]" gap={0} px={10} wrap={"nowrap"}>
      <Avatar.Group>
        {avatars.map((avatar, index) => (
          <Avatar
            key={index}
            alt={`avatar n° ${index + 1}`}
            aria-label={`avatar n° ${index + 1}`}
            className="border-none bg-transparent"
            imageProps={{
              title: `avatar n° ${index + 1}`,
              width: 44,
              height: 44,
            }}
            size={44}
            src={avatar}
            title={`avatar n° ${index + 1}`}
          />
        ))}
      </Avatar.Group>
      <ChipText className={className} label={text} />
    </Group>
  );
};

export default AvatarWithText;
